import {
  IMeta,
  IResultStamp,
} from "@/api/AppApi/common-interfaces/IResultStamp";
import { IBlog } from "../../home/interfaces/Blog";
export interface IBlogsGetAllParams {
  category?: string;
  sort_by?: string;
  date?: string;
  author_id?: number;
  authors?: string;
  tags?: string;
  page?: number;
  limit?: number;
}
export interface IGetAllBlogCommentsParams {
  page?: number;
  limit?: number;
}
export interface IBlogsCategory {
  key: string;
  value: string;
  blogs_count: number;
  image_url?:string
  meta: MetaData;
}
export interface IBlogsArchive extends IBlogsCategory {}

export interface IBlogTag {
  key: string;
  value: string;
}
export interface IBlogAuther {
  id?: number;
  name: string;
  email: string | null;
  image_url: string | null;
  status?: string;
}

export interface IBlogDetails {
  blog: IBlog;
  categories: IBlogsCategory[];
  recent_blogs: IBlog[];
  author_blogs: IBlog[];
  archives: IBlogsArchive[];
  next_previous_blogs: {
    next: IBlog | null;
    prev: IBlog | null;
  };
  should_redirect?: boolean;
  slug?: string;
}

export interface IGetAllBlogs extends IResultStamp {
  result: {
    data: IBlog[];
    meta: IMeta;
  };
}

export interface IGetBlogDetails extends IResultStamp {
  result: IBlogDetails;
}
export interface IBlogsCategories {
  categories: IBlogsCategory[];
  recent_blogs: IBlog[];
  archives: IBlogsArchive[];
  tags: IBlogTag[];
}
export interface IGetBlogsCategories extends IResultStamp {
  result: IBlogsCategories;
}
export enum CommentReactions {
  liked = "liked",
  disliked = "dislike",
}
export interface IComment {
  id: number;
  content: string;
  user: IBlogAuther;
  date: string;
  timestamp_date?: number;
  replies_count?: number;
  replies?: IComment[];

  dislikes: number;
  likes: number;
  reaction: CommentReactions | null;
}

export interface IGetAllBlogComments extends IResultStamp {
  result: {
    data: IComment[];
    meta: IMeta;
  };
}

export interface ISubmitCommentResponse extends IResultStamp {
  result: IComment;
}

export interface IPostBlogCommentLikeToggle extends IResultStamp {
  result: {
    liked: boolean;
    dislike_deleted: boolean;
  };
}
export interface IPostBlogCommentDislikeToggle extends IResultStamp {
  result: {
    dislike: boolean;
    like_deleted: boolean;
  };
}

export interface IBlogLikeToggle extends IResultStamp {
  result: {
    liked: true;
  };
}

export interface MetaData {
  meta_title: string;
  meta_keyword: string;
  meta_description: string;
  og_title: string;
  og_description: string;
  og_image_url: string;
}

export interface IBlogAuthorListItem {
  id: number;
  name: string;
  image_url: string | null;
  slug: string;
  blogs_count: number;
}

export interface IGetAuthorsParams {
  name?: string;
  page?: number;
  per_page?: number;
}

export interface IGetAuthorsResponse {
  message: {
    text: string;
    type: string;
  };
  result: {
    data: IBlogAuthorListItem[];
    meta: IMeta;
  };
}
